export default __webpack_public_path__ + "static/hendricks-79e4cdb36a5d71d0b2c3d0355d72ad11.jpg";